/// <amd-module name="InstantSearch/Shared/Utils" />

import { IVssPageContext } from "VSS/Platform/Context";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";

/**
 * Utility method to form query text with wild card char on last word. 
 * i.e., for search string "one two" it returns "one (two OR two*)"
 * @param value - search string
 */
export function getQueryTextWithWildCardChar(value: string): string {
    const searchText = value.trim();
    if (searchText) {
        if (searchText.endsWith("\"")
            || searchText.endsWith("*")
            || searchText.endsWith("@me")
            || isTimeLiteral(searchText)
        ) {
            return searchText;
        } else {
            return searchText + "*";
        }
    }

    return "";
}

/**
 * Utility method to confirm if search string ends with time literal. 
 * i.e., returns true if search string ends with `@today +/- <number>`
 * @param text - search string
 */
function isTimeLiteral(text: string): boolean {
    const index = text.lastIndexOf("@today");
    const containsToday = index != -1;
    if (containsToday) {
        const subString = text.substr(index);
        const regexp = new RegExp('^@today(\\s)*([+-])*(\\s)*[0-9]*$');
        return regexp.test(subString);
    }

    return false;
}

/**
 * Utility method to get settings value
 */
export function getSetting<T>(pageContext: IVssPageContext, key: string, defaultValue: T): T {
    const settingsService = pageContext.getService<ISettingsService>("ISettingsService");
    const value = settingsService.getEntry<T>(key, SettingsUserScope.Host);
    if (value == null) {
        return defaultValue;
    }
    return value;
}

/**
 * Browser util to find whether script is running on IE
 */
export function isIE(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const msie = /msie ([\d+.]+)/i.exec(navigator.userAgent);

    return !!msie || userAgent.indexOf("trident") !== -1;
}
